<template>
  <div>
    <h1 class="settings-title">
      Webhooks
    </h1>
    <button
      class="btn btn-main btn-round mb-3"
      :disabled="!webhooksLoaded"
      @click="openWebhookSaveModal()">Create New Webhook</button>

    <b-table
      :fields="fields"
      :items="webhooks"
      show-empty
      responsive
      class="merchant-dashboard__table scroll-area-horizontal">

      <!-- Selected webhook column -->
      <template v-slot:cell(selected_webhooks)="data">
        <span
          v-for="webhook in data.item.selected_webhooks"
          :key="webhook">
          {{ webhook }}<br>
        </span>
      </template>

      <!-- Status column -->
      <template v-slot:cell(active)="data">
        <span
          :class="data.item.active ? 'success' : 'warning'"
          class="tag-item">{{ data.item.active ? 'Active' : 'Disabled' }}</span>
      </template>

      <!-- Actions column -->
      <template v-slot:cell(actions)="data">
        <b-dropdown
          right
          no-flip
          no-caret
          class="actions">
          <!-- button -->
          <template v-slot:button-content>
            <icon name="ellipsis-h"/>
          </template>
          <!-- Items -->
          <b-dropdown-item @click="openWebhookDetailsModal(data.item)">
            Webhook Details
          </b-dropdown-item>
          <b-dropdown-item @click="openWebhookSaveModal(data.item)">
            Edit Webhook
          </b-dropdown-item>
          <b-dropdown-item
            @click="openDeleteWebhookModal(data.item)">
            Delete
          </b-dropdown-item>
        </b-dropdown>
      </template>

      <!-- No data content -->
      <template v-slot:empty="">
        <div
          v-if="!webhooks.length && !webhooksLoaded"
          slot="empty"
          class="loader">
          <div class="loading-circle"/>
        </div>
      </template>
    </b-table>

    <div class="description-box">
      *To learn more about webhooks check our <a
        :href="webhookDocsUrl"
        target="_blank">API Documentation</a>
    </div>
    <WebhookDetailsModal
      ref="webhookDetailsModal"
      :webhookp="selectedWebhook"/>
    <WebhookSaveModal
      ref="webhookSaveModal"
      :webhookp="selectedWebhook"
      @saved="fetchWebhooks($route.params.merchant_id)"/>
    <WebhookDeleteModal
      ref="webhookDeleteModal"
      :webhookp="selectedWebhook"
      @deleted="fetchWebhooks($route.params.merchant_id)"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import WebhookDetailsModal from './modals/WebhookDetailsModal';
import WebhookSaveModal from './modals/WebhookSaveModal';
import WebhookDeleteModal from './modals/WebhookDeleteModal';

export default {
  name: 'WebhookSettings',
  components: {
    WebhookDetailsModal,
    WebhookSaveModal,
    WebhookDeleteModal,
  },
  data() {
    return {
      fields: [
        'url',
        {
          key: 'selected_webhooks',
          label: 'Selected Webhooks',
        },
        {
          key: 'active',
          label: 'Status',
        },
        {
          key: 'actions',
          class: 'text-right',
        },
      ],
      selectedWebhook: {},
    };
  },
  computed: {
    ...mapGetters({
      webhooks: 'webhook/webhooks',
      webhooksLoaded: 'webhook/webhooksLoaded',
      sendbeeDevelopersDocs: 'system/sendbeeDevelopersDocs',
    }),
    webhookDocsUrl() {
      return `${this.sendbeeDevelopersDocs}/#webhooks`;
    },
  },
  mounted() {
    this.fetchWebhooks(this.$route.params.merchant_id);
  },
  methods: {
    ...mapActions({
      fetchWebhooks: 'webhook/fetchWebhooks',
    }),
    openWebhookDetailsModal(webhook = {}) {
      this.selectedWebhook = webhook;
      this.$nextTick(() => {
        this.$refs.webhookDetailsModal.show();
      });
    },
    openWebhookSaveModal(webhook = {}) {
      this.selectedWebhook = webhook;
      this.$nextTick(() => {
        this.$refs.webhookSaveModal.show();
      });
    },
    openDeleteWebhookModal(webhook) {
      this.selectedWebhook = webhook;
      this.$refs.webhookDeleteModal.show();
    },
  },
};
</script>
